module.exports = __webpack_public_path__ + "img/files_blue.1e455917.svg";